import React, {Component} from 'react';
import {getJwt} from '../../services/authService';
import http from '../../services/httpService';
import ChartLoader from '../utils/chart-loader';
import NewTrigger from './NewTrigger';
import SingleTrigger from './SingleTrigger';
import toastr from 'toastr';
import Joyride, {STATUS} from "react-joyride";


class SmsChannelTriggers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createNewTriggerActive: false,
            loader: false,
            selectedSource: '',
            defaultResponse: {},
            reservedTriggers: [
                {
                    name: 'Stop',
                    infoDescription: 'When Emitto receives an Unsubscribe keyword from an external sender phone number to any of ' +
                        'your workspace associated numbers, Emitto will reply with an automatic message and will no longer send ' +
                        'messages to that external phone number until the sender resubscribe in by sending any of the Resubscribe keywords. ' +
                        'Default reserved keyword are "STOP" and "UNSUBSCRIBE", but you can add more custom keywords here. ' +
                        'You can also customise the automatic message.',
                    actions: [
                        {
                            type: 'Event',
                            value: 0
                        },
                        {
                            type: 'Reply with SMS',
                            value: 'You have successfully been unsubscribed, You will not receive any more messages from this number. Reply START to resubscribe.',
                        }
                    ],
                    keywords: ['cancel', 'end', 'quit', 'stopall'],
                    reserved_keywords: ['stop', 'unsubscribe'],
                },
                {
                    title: 'Start',
                    infoDescription: 'When Emitto receives an Resubscribe keyword from an unsubscribed external sender phone number ' +
                        'the contact will be re-subscribed and will again start receiving your campaigns. They will also get ' +
                        'an automatic message for a successful re-subscription. Default reserved keyword is "START", but you can ' +
                        'add more custom keywords here. You can also customise the automatic message.',
                    actions: [
                        {
                            type: 'Event',
                            subscribe: 1
                        },
                        {
                            type: 'Reply with SMS',
                            value: 'You have successfully been re-subscribed to messages from this number. Reply HELP for help. Reply Stop to unsubscribe. Msg&Data Rates May Apply.',
                        }
                    ],
                    keywords: ['yes', 'unstop'],
                    reserved_keywords: ['start'],
                },
                {
                    title: 'Help',
                    infoDescription: 'When Emitto receives any of these keywords it will return basic helpful information, ' +
                        'for example how to unsubscribe or resubscribe. Default reserved keyword is "HELP", but you can add more ' +
                        'custom keywords here. You can also customise the automatic message.',
                    actions: [
                        {
                            type: 'Reply with SMS',
                            value: 'Reply STOP to unsubscribe. Msg&Data Rates May Apply.',
                        }
                    ],
                    keywords: ['info'],
                    reserved_keywords: ['help'],
                }
            ],
            customTriggers: [],
            //tour settings

            tourRun: this.props.tourRun,
            steps: [
                {
                    content:
                        <div>
                            <h2>Triggers and Custom Actions are live! 😄</h2>
                            <p>Now you can define custom triggers and keywords to perform actions when your SMS
                                recipients
                                reply to your number.
                            </p>
                            <p>Note: This only works if you have a dedicated phone number associated to your workspace
                                and
                                if your messages are being sent via the number.
                            </p>
                        </div>,
                    placement: 'center',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.triggers-tour-step-1',
                    title: '',
                },
                {
                    content: 'There are 3 reserved triggers for Unsubscribe, Resubscribe and Help keywords, but you can also define custom triggers for your own use case.\n',
                    placement: 'auto',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.triggers-tour-step-2',
                    title: '',
                },
                {
                    content: 'You can update reserved triggers with keywords in your own language as well. 🔠',
                    placement: 'auto',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.triggers-tour-step-3',
                    title: '',
                },

                {
                    content: 'You can modify the Response Message and add new Actions such as Reply with SMS, Assign Tag, set up and Even and add your custom Webhook URL.',
                    placement: 'top',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    disableScrolling: true,
                    target: '.triggers-tour-step-4',
                    title: '',
                },

            ]
        }
    }


    async componentDidMount() {
        this.handleGetTriggers()
        this.setState({selectedSource: this.props.selectedSource})
    }

    componentDidUpdate = () => {
        if (this.state.selectedSource !== this.props.selectedSource) {
            this.setState({selectedSource: this.props.selectedSource})
            this.handleGetTriggers();
        }
        if (this.state.tourRun !== this.props.tourRun) {
            this.setState({
                tourRun: this.props.tourRun
            })
        }
    }

    handleGetTriggers = async () => {
        let userId = this.props.user.id;
        let selectedSource = this.props.selectedSource;
        this.setState({loader: true})
        try {
            const workspace_triggers = await http.get('api/user/' + userId + '/project/' + selectedSource + '/workspace_triggers', {headers: {authorization: getJwt()}});

            const customTriggers = [];
            await workspace_triggers.data.keywords.map(keyword => keyword.type === 'custom' ? customTriggers.push(keyword) : '');
            let stop = workspace_triggers.data.keywords.find(trigger => trigger.type === 'unsubscribe');
            let start = workspace_triggers.data.keywords.find(trigger => trigger.type === 'subscribe');
            let help = workspace_triggers.data.keywords.find(trigger => trigger.type === 'help');
            let defaultResponse = workspace_triggers.data.keywords.find(trigger => (trigger.type === 'response-inactive') || (trigger.type === 'response-active'))
            // await customTriggers.filter(keyword => keyword.type === 'custom');

            // console.log('workspace_triggers: ', workspace_triggers.data.keywords, customTriggers)

            this.setState({
                defaultResponse: {
                    ...this.state.defaultResponse,
                    ...defaultResponse
                },
                reservedTriggers: [
                    {
                        ...this.state.reservedTriggers[0],
                        ...stop
                    },
                    {
                        ...this.state.reservedTriggers[1],
                        ...start
                    },
                    {
                        ...this.state.reservedTriggers[2],
                        ...help
                    }
                ],
                customTriggers,
                loader: false
            })
        } catch {
            this.setState({loader: false})
            toastr.error('Error with getting triggers, please reload page')
        }

    }

    handleSaveReserved = (data, key) => {
        let reservedTriggers = this.state.reservedTriggers;
        reservedTriggers[key] = {
            ...this.state.reservedTriggers[key],
            triggersList: data.keywords,
            message: data.message,
            actions: data.actions
        }
        this.setState({reservedTriggers})
    }
    getHelpers = (StoreHelpers) => {
        this.helpers = StoreHelpers;
    };

    handleJoyrideCallback = (data) => {
        //console.log('joyride callback data: ', data)

        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            this.props.turnOffTour()
        }

        if (data.index === 3) {
            //console.log('.triggers-tour-step-3 .single-trigger-container:first-of-type: ', document.querySelector('.triggers-tour-step-3 .single-trigger-container:first-of-type .edit-text'))
            //document.querySelector('.triggers-tour-step-3 .single-trigger-container:first-of-type .edit-text').click()
            if (document.querySelector('.triggers-tour-step-3 .single-trigger-container:first-of-type .edit-text')) {

                document.querySelector('.triggers-tour-step-3 .single-trigger-container:first-of-type .edit-text').click()
                setTimeout(() => {
                    window.scroll({
                        top: 400,
                        behavior: 'smooth'
                    })
                }, 500)
            }
        }

    }

    handleSaveCustom = (data, key) => {
        // console.log('handleSaveCustom: ', data, key)
        let customTriggers = this.state.customTriggers;
        customTriggers[key] = {
            ...this.state.customTriggers[key],
            triggersList: data.keywords,
            message: data.message,
            actions: data.actions
        }
        this.setState({customTriggers})
    }

    handleSaveNew = (data) => {
        let customTriggers = [
            ...this.state.customTriggers,
            {
                title: data.title,
                triggersList: data.keywords,
                actions: data.actions
            }
        ]
        this.setState({customTriggers})
    }


    render() {
        const {tourRun, steps} = this.state
        return (

            <div className="channel-container triggers-tour-step-1" ref={el => (this.container = el)}>
                <Joyride
                    callback={this.handleJoyrideCallback}
                    continuous={true}
                    getHelpers={this.getHelpers}
                    run={tourRun}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={steps}
                    styles={{
                        options: {
                            zIndex: 10000,
                            primaryColor: '#26AAE1'
                        },
                    }}
                />
                <div className="channel-heading-container display-flex align-items-center">
                    <h3>MANAGE TRIGGER WORDS</h3>
                </div>
                <p className="trigger-explanation">
                    Define custom keywords that automatically trigger specific actions when replied to your message.
                </p>
                <div className="triggers-container">
                    <p className="section-title">Default Trigger</p>
                    {this.state.loader ?
                        <ChartLoader/>
                        :
                        <SingleTrigger
                            key={1}
                            name={'Default Response'}
                            infoDescription={'Define the actions that happen by default when you receive a message that is not triggered by your reserved or custom keywords.'}
                            // message={trigger.message}
                            type={this.state.defaultResponse.type}
                            batchTime={this.state.defaultResponse.batch_time}
                            keywords={this.state.defaultResponse.keywords}
                            reservedTrigger={false}
                            reservedKeywords={this.state.defaultResponse.reserved_keywords}
                            actions={this.state.defaultResponse.actions}
                            tags={this.props.tags}
                            handleCreateTag={this.props.handleCreateTag}
                            handleGetTags={this.props.handleGetTags}
                            selectedSource={this.props.selectedSource}
                            user={this.props.user}
                            updateUserFromServer={this.props.updateUserFromServer}
                            description={this.state.defaultResponse.description}
                            handleGetTriggers={this.handleGetTriggers}
                            handleSave={(data) => this.handleSaveDefaultResponse(data)}
                        />
                    }
                    <div className='triggers-tour-step-2 triggers-tour-step-3  triggers-tour-step-4'>
                        <p className="section-title">Reserved Triggers</p>

                        {this.state.loader ?
                            <ChartLoader/>
                            :
                            this.state.reservedTriggers.map((trigger, key) => <SingleTrigger
                                    key={key}
                                    name={trigger.name}
                                    infoDescription={trigger.infoDescription}
                                    // message={trigger.message}
                                    type={trigger.type}
                                    batchTime={trigger.batch_time}
                                    keywords={trigger.keywords}
                                    reservedTrigger={true}
                                    reservedKeywords={trigger.reserved_keywords}
                                    actions={trigger.actions}
                                    tags={this.props.tags}
                                    handleCreateTag={this.props.handleCreateTag}
                                    handleGetTags={this.props.handleGetTags}
                                    selectedSource={this.props.selectedSource}
                                    user={this.props.user}
                                    updateUserFromServer={this.props.updateUserFromServer}
                                    description={trigger.description}
                                    handleGetTriggers={this.handleGetTriggers}
                                    handleSave={(data) => this.handleSaveReserved(data, key)}
                                />
                            )
                        }
                    </div>
                </div>
                <div className="triggers-container">
                    <p className="section-title">Custom Triggers</p>
                    <NewTrigger
                        // handleSave={this.handleSaveNew}
                        tags={this.props.tags}
                        handleCreateTag={this.props.handleCreateTag}
                        handleGetTags={this.props.handleGetTags}
                        selectedSource={this.props.selectedSource}
                        user={this.props.user}
                        handleGetTriggers={this.handleGetTriggers}
                        updateUserFromServer={this.props.updateUserFromServer}
                    />
                    {this.state.loader ?
                        <ChartLoader/>
                        :
                        this.state.customTriggers.map((trigger, key) => <SingleTrigger
                            key={key}
                            customTrigger={true}
                            name={trigger.name}
                            // infoDescription={trigger.infoDescription}
                            type={trigger.type}
                            message={trigger.message}
                            actions={trigger.actions}
                            tags={this.props.tags}
                            handleCreateTag={this.props.handleCreateTag}
                            handleGetTags={this.props.handleGetTags}
                            selectedSource={this.props.selectedSource}
                            user={this.props.user}
                            updateUserFromServer={this.props.updateUserFromServer}
                            triggersList={trigger.triggersList}
                            handleSave={(data) => this.handleSaveCustom(data, key)}
                            handleGetTriggers={this.handleGetTriggers}
                            batchTime={trigger.batch_time}
                            keywords={trigger.keywords}
                        />)
                    }
                </div>
            </div>
        )

    }
}


export default SmsChannelTriggers;